export default {
  data() {
    return {
      visibleList: 0,
      offsetting: 0,
      Theight: 0,
      itemHeight: 0,
      isVirtual: true,
      start: 0,
      end: 0,
      thHight: 0,
    }
  },
  computed: {
    data() {
      // 修改el-table加载数据逻辑
      if (this.isVirtual) {
        return this.table.tableData.slice(this.start, this.end)
      } else {
        return this.table.tableData
      }
    },
  },
  watch: {
    'table.tableData'(value) {
      if (this.isVirtual) {
        this.handleVirtualTable(value)
      }
    },
    '$parent.$attrs.Theight'(val) {
      this.Theight = val;
      this.onResizes();
    }
  },
  beforeDestroy() {
    this.handleScroll = null
  },
  created() {
    this.isVirtual = this.$parent.$attrs.isVirtual
    // 开启虚拟列表需要固定列表高度，默认500
    // 可动态设置Theight

    this.Theight = this.$parent.$attrs.Theight || 500
    // debugger
    this.itemHeight = this.$parent.$attrs.itemHeight || 70
    // 缩放浏览器时需要重新计算
    this.$nextTick(() => {
      this.thHight = document.querySelector('.el-table__header').clientHeight
      if (this.isVirtual) {
        this.Theight = document.querySelector('.el-table').scrollHeight
        let scrollContainer = document.querySelector('.is-scrolling-none')
        this.handleVirtualTable(this.table.tableData)
        window.addEventListener('resize', () => {
          this.onResizes();
        })
      }
    })
  },
  methods: {
    onResizes() {
      let scrollContainer = document.querySelector('.is-scrolling-none')
      if(!scrollContainer){
        return false
      }
      // 減去表格头部高度
      scrollContainer.style.height = this.Theight - this.thHight
      scrollContainer.style.width = '100%'
      // 列表数据初始化（可见条数）
      this.visibleList = Math.ceil((scrollContainer.clientHeight) / this.itemHeight)
      this.end = this.start + this.visibleList
    },
    handleVirtualTable(data) {
      this.$nextTick(() => {
        let
          virtualDiv = document.querySelector('#virtualDiv'),
          tableBody = document.querySelector('.el-table__body'),
          scrollContainer = document.querySelector('.is-scrolling-none')

        scrollContainer.style.overflowY = 'auto'
        scrollContainer.style.overflowX = 'hidden'
        let width = document.documentElement.clientWidth || document.body.clientWidth
        scrollContainer.style.width = `${width}px`
        scrollContainer.style.height = `${this.Theight - this.thHight || 500}px`
        scrollContainer.addEventListener('scroll', this.handleScroll, true)

        // 虚拟滚动条
        if (!virtualDiv) {
          virtualDiv = document.createElement('div')
          virtualDiv.id = 'virtualDiv'
          virtualDiv.style.height = `${data.length * this.itemHeight + 15}px`
          let dom = document.querySelector('.el-table__append-wrapper')
          scrollContainer.insertBefore(virtualDiv, dom);
        } else {
          virtualDiv.style.height = `${data.length * this.itemHeight + 15}px`
        }

        // 脱离虚拟列表 避免影响高度
        Object.assign(tableBody.style, {
          position: 'absolute',
          left: 0,
          top: 0,
        })

        this.end = this.visibleList = Math.ceil(
          (scrollContainer.clientHeight) / this.itemHeight
        )
        this.handleScroll()
      })
    },
    handleScroll(event) {
      this.$nextTick(()=>{
        let scrollTop = event ? event.target.scrollTop : document.querySelector('.is-scrolling-none').scrollTop
        this.start = Math.floor(scrollTop / this.itemHeight) < 0 ? 0 : Math.floor(scrollTop / this.itemHeight)
        this.end = this.start + this.visibleList
        this.offsetting = scrollTop - (scrollTop % this.itemHeight)
        document.querySelector(
          '.el-table__body'
        ).style.transform = `translateY(${this.offsetting}px)`
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/plugins/tableMixins.js